export default __webpack_public_path__ + "static/media/netent-logo.a1907d15.svg";